const OrganizationTicketIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="4" fill="#E4F4FF" />
      <path
        d="M24.3333 16.0001C24.3333 20.6025 20.6023 24.3334 16 24.3334M24.3333 16.0001C24.3333 11.3977 20.6023 7.66675 16 7.66675M24.3333 16.0001C24.3333 14.6194 20.6023 13.5001 16 13.5001C11.3976 13.5001 7.66663 14.6194 7.66663 16.0001M24.3333 16.0001C24.3333 17.3808 20.6023 18.5001 16 18.5001C11.3976 18.5001 7.66663 17.3808 7.66663 16.0001M16 24.3334C11.3976 24.3334 7.66663 20.6025 7.66663 16.0001M16 24.3334C17.8409 24.3334 19.3333 20.6025 19.3333 16.0001C19.3333 11.3977 17.8409 7.66675 16 7.66675M16 24.3334C14.159 24.3334 12.6666 20.6025 12.6666 16.0001C12.6666 11.3977 14.159 7.66675 16 7.66675M7.66663 16.0001C7.66663 11.3977 11.3976 7.66675 16 7.66675"
        stroke="#2497EB"
        stroke-width="1.25"
      />
    </svg>
  );
};

export default OrganizationTicketIcon;
